import { useRouter } from '@tribeplatform/react-sdk'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { CustomFieldViewProps, getFieldIcon } from '../utils.js'

export const SocialMediaView = ({ field, value }: CustomFieldViewProps) => {
  const { Link } = useRouter()
  return (
    <Tooltip>
      <Tooltip.Trigger>
        <Link
          href={value}
          target="_blank"
          className="w-6 h-6 flex-shrink-0 hover:opacity-80"
          onClick={e => e.stopPropagation()}
        >
          {getFieldIcon(field)}
        </Link>
      </Tooltip.Trigger>
      <Tooltip.Panel>{field?.name}</Tooltip.Panel>
    </Tooltip>
  )
}

SocialMediaView.skipLabel = true
